import { useSelector, shallowEqual } from 'react-redux';

const useShallowEqualSelector = (selector) => {
  const wrappedSelector = (state) => {
    const selected = selector(state);
    if (selected === state) {
      // Hack: clone the state to avoid Redux dev warning
      return { ...selected };
    }
    return selected;
  };

  return useSelector(wrappedSelector, shallowEqual);
};

export default useShallowEqualSelector;
